import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import { Subject, takeUntil } from 'rxjs';
import {
    ComponentFactoryConfig,
    ComponentFactoryDirective,
} from '../componentFactory/component-factory.directive';
import { CkEditorComponent } from './ck-editor/ck-editor.component';
import { OrgNavigationService } from 'app/services/org-nav.service';

@Component({
    selector: 'custom-ck-editor',
    imports: [CkEditorComponent, ComponentFactoryDirective],
    templateUrl: './custom-ck-editor.component.html',
    styleUrl: './custom-ck-editor.component.scss',
})
export class CustomCkEditorComponent implements OnInit, AfterViewInit, OnDestroy {
    private _destroy: Subject<void> = new Subject();

    @Input() formGroup: FormGroup;
    @Input() fcName: string;

    showTransactionAiButton: boolean = false;
    showAifButton: boolean = false;

    private activeLang: string;
    ckEditorConfig: ComponentFactoryConfig;

    constructor(
        private _translocoService: TranslocoService,
        private orgNav: OrgNavigationService
    ) {
        this.activeLang = this._translocoService.getActiveLang();
        this.showTransactionAiButton = this.orgNav.url.includes('sapTask');
        this.showAifButton = this.orgNav.url.includes('bp/task');
    }

    ngOnInit(): void {
        this.setUpDescriptionComponent();
    }
    ngAfterViewInit(): void {
        this._translocoService.langChanges$
            .pipe(takeUntil(this._destroy))
            .subscribe((newLanguage: string) => {
                if (this.activeLang !== newLanguage) {
                    this.activeLang = newLanguage;
                    this.setUpDescriptionComponent();
                }
            });
    }
    ngOnDestroy(): void {
        this._destroy.next();
        this._destroy.complete();
    }

    private setUpDescriptionComponent(): void {
        this.ckEditorConfig = undefined;
        this.ckEditorConfig = {
            ...{
                component: CkEditorComponent,
                data: new Map<string, any>([
                    ['formGroup', this.formGroup],
                    ['formControlName', this.fcName],
                    ['showTransactionAiButton', this.showTransactionAiButton],
                    ['showAifButton', this.showAifButton],
                ]),
            },
        };
    }
}
